import { ColumnOptions } from './Table.types';

export function isColumnOptions(obj: unknown): obj is ColumnOptions {
    return typeof obj === 'object' && !!obj && 'title' in obj;
}

export const getColumnKey = (key: string) => {
    return key.replace(/\./g, '-');
};
